module.exports = __webpack_public_path__ + "img/mision1.d18f3087.png";